import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69df92d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "offline-bg"
}
const _hoisted_2 = { class: "offline-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "offline-header-mobile" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Trailer Solution")
], -1))
const _hoisted_4 = { class: "offline-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column message-box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header" }, "No Service"),
  /*#__PURE__*/_createElementVNode("div", { class: "message" }, " Trailer Solution cannot be performed without an active connection. ")
], -1))
const _hoisted_6 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fbx_button = _resolveComponent("fbx-button")!

  return (!_ctx.online || _ctx.networkTimeout)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_fbx_button, {
                "button-text": "Retry",
                theme: "primary",
                onClick: _ctx.retry
              }, null, 8, ["onClick"])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}